(function () {
  var lastFocusedElement = null;

  function formatMoneyFromCents(cents) {
    var value = (Number(cents) || 0) / 100;
    return "$" + value.toFixed(2);
  }

  function renderDrawer(cart) {
    var content = document.querySelector("[data-cart-drawer-content]");
    if (!content) return;

    if (!cart || !cart.items || !cart.items.length) {
      content.innerHTML =
        '<p class="kp-body kp-body--muted">Your cart is empty.</p>' +
        '<a class="kp-btn kp-btn--primary" href="/collections/all">Continue shopping</a>';
      return;
    }

    var itemsHtml = cart.items
      .map(function (item) {
        var imageHtml = item.image
          ? '<img class="kp-cart-drawer__image" src="' + item.image + '" alt="' + item.product_title + '">'
          : "";

        return (
          '<article class="kp-cart-drawer__item">' +
          imageHtml +
          '<div class="kp-cart-drawer__item-copy">' +
          '<p class="kp-label">' +
          item.vendor +
          "</p>" +
          '<h3 class="kp-title kp-title--product">' +
          item.product_title +
          "</h3>" +
          '<p class="kp-price">' +
          formatMoneyFromCents(item.final_line_price) +
          "</p>" +
          '<p class="kp-body kp-body--muted">Qty ' +
          item.quantity +
          "</p>" +
          "</div>" +
          "</article>"
        );
      })
      .join("");

    content.innerHTML =
      '<div class="kp-cart-drawer__list">' +
      itemsHtml +
      "</div>" +
      '<div class="kp-cart-drawer__footer">' +
      '<p class="kp-title">Subtotal: ' +
      formatMoneyFromCents(cart.total_price) +
      "</p>" +
      '<a class="kp-btn kp-btn--secondary" href="/cart">View cart</a>' +
      '<a class="kp-btn kp-btn--primary" href="/checkout">Checkout</a>' +
      "</div>";
  }

  function openDrawer() {
    var drawer = document.querySelector("[data-cart-drawer]");
    var closeButton = document.querySelector(".kp-cart-drawer__close");
    if (!drawer) return;
    lastFocusedElement = document.activeElement;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("kp-no-scroll");
    if (closeButton) closeButton.focus();
  }

  function closeDrawer() {
    var drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("kp-no-scroll");
    if (lastFocusedElement && typeof lastFocusedElement.focus === "function") {
      lastFocusedElement.focus();
    }
  }

  function refreshDrawer() {
    return fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderDrawer(cart);
      })
      .catch(function () {});
  }

  function setupDrawerTriggers() {
    document.addEventListener("click", function (event) {
      var explicitDrawerTrigger = event.target.closest("[data-open-cart-drawer]");
      var anchor = event.target.closest("a[href]");
      var isCartLink = false;

      if (anchor) {
        try {
          var parsed = new URL(anchor.href, window.location.origin);
          isCartLink = parsed.pathname === "/cart";
        } catch (error) {
          isCartLink = false;
        }
      }

      if (explicitDrawerTrigger || isCartLink) {
        event.preventDefault();
        refreshDrawer().then(openDrawer);
      }

      if (event.target.closest("[data-cart-drawer-close]")) {
        event.preventDefault();
        closeDrawer();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      var drawer = document.querySelector("[data-cart-drawer]");
      if (drawer && drawer.classList.contains("is-open")) {
        closeDrawer();
      }
    });
  }

  function setupAjaxProductForms() {
    var forms = document.querySelectorAll("form[data-ajax-add-to-cart]");
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var message = form.querySelector("[data-cart-message]");
        var formData = new FormData(form);

        fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" }
        })
          .then(function (response) {
            if (!response.ok) throw new Error("Add to cart failed");
            return response.json();
          })
          .then(function () {
            if (message) {
              message.textContent = "Added to cart.";
            }
            return refreshDrawer();
          })
          .then(openDrawer)
          .catch(function () {
            if (message) {
              message.textContent = "Unable to add to cart. Please try again.";
            }
          });
      });
    });
  }

  function setActiveMedia(mediaId, root) {
    if (!mediaId || !root) return;
    var target = root.querySelector('[data-media-item="' + mediaId + '"]');
    if (!target) return;

    var thumbs = root.querySelectorAll("[data-media-thumb]");
    thumbs.forEach(function (thumb) {
      thumb.classList.toggle("is-active", thumb.getAttribute("data-media-thumb") === String(mediaId));
    });

    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function setupVariantMediaSync() {
    var productRoots = document.querySelectorAll("[data-product-root]");
    if (!productRoots.length) return;

    productRoots.forEach(function (root) {
      var selector = root.querySelector("[data-variant-selector]");
      if (!selector) return;

      selector.addEventListener("change", function () {
        var selectedOption = selector.options[selector.selectedIndex];
        if (!selectedOption) return;
        var mediaId = selectedOption.getAttribute("data-variant-media-id");
        setActiveMedia(mediaId, root);
      });
    });
  }

  function setupMobileNav() {
    var toggles = document.querySelectorAll("[data-nav-toggle]");
    if (!toggles.length) return;

    toggles.forEach(function (toggle) {
      var controlsId = toggle.getAttribute("aria-controls");
      if (!controlsId) return;
      var panel = document.getElementById(controlsId);
      if (!panel) return;

      toggle.addEventListener("click", function () {
        var isOpen = panel.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });

      panel.querySelectorAll("a").forEach(function (link) {
        link.addEventListener("click", function () {
          panel.classList.remove("is-open");
          toggle.setAttribute("aria-expanded", "false");
        });
      });
    });
  }

  setupDrawerTriggers();
  setupAjaxProductForms();
  setupVariantMediaSync();
  setupMobileNav();
})();
